import { createSelector } from 'reselect';

export const getSearches = state => state.savedSearches.searches;
export const isLoading = state => state.savedSearches.loading;
export const getDeleteSavedSearch = state => state.savedSearches.deleteSavedSearch;

export const hasSearches = createSelector(
  [getSearches],
  searches => !!searches && searches.length > 0
);